module.exports = __webpack_public_path__ + "img/noAny.c7e42974.svg";